import { motion, useReducedMotion } from "framer-motion";
import { useEffect, useState } from "react";

const quotes = [
  {
    text: "Truly a one-man department.",
    author: "Iraklis Anastasiou",
    role: "Research Analyst, CoinTelegraph",
  },
  {
    text: "Executes with confidence.",
    author: "Paul Kruegel",
    role: "Advisor & Solo Founder",
  },
  {
    text: "An effortless eye for detail.",
    author: "Michael Rhoden",
    role: "BD, TicTacc",
  },
];

const QuotesStrip = () => {
  const prefersReduced = useReducedMotion();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    setIsMobile(window.innerWidth < 640);
  }, []);

  return (
    <section className="py-14 border-y border-border/30">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {quotes.map((q, i) => (
            <motion.div
              key={q.author}
              initial={prefersReduced || isMobile ? { opacity: 0 } : { opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: prefersReduced ? 0 : i * 0.15, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="text-center md:text-left"
            >
              <p className="font-display text-lg text-foreground leading-snug mb-3">
                <span className="text-primary">&ldquo;</span>
                {q.text}
                <span className="text-primary">&rdquo;</span>
              </p>
              <p className="text-xs font-body text-muted-foreground">
                {q.author}
              </p>
              <p className="text-xs font-body text-muted-foreground">
                {q.role}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuotesStrip;
